import { ComponentProps } from "react";

import { SPRITE_SYMBOLS } from "@/assets/icons/sprite/IconSprite";
import { SpriteIcon } from "@/assets/icons/sprite/SpriteIcon";

/*
 * Sprite-backed (see `@/assets/icons/sprite/IconSprite`): a product grid draws this 24 times.
 * `scripts/figma-icons.ts` skips this file on regeneration; the path lives in the sprite.
 */
export const IconStateHeartOutline = (props: ComponentProps<"svg">) => (
  <SpriteIcon
    symbol={SPRITE_SYMBOLS.heartOutline}
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    {...props}
  />
);
